module.exports = __webpack_public_path__ + "img/poi-teacat.27250d88.png";